<template>
  <div>
    <div class="header">
      <span style="color: green" v-if="isConnected">已连接</span>
      <span style="color: red" v-if="!isConnected">未连接</span>

      <input v-model="wsUrl" placeholder="Enter WebSocket URL"/>
      <button @click="connectWebSocket">Connect</button>
    </div>
    <div>
      Token:
      <input v-model="token" placeholder="Enter Token" size="150"/>
    </div>
    <div>
      Action:
      <select v-model="selectedAction">
        <optgroup v-for="(group, tag) in groupedActions" :label="tag || 'General'" :key="tag">
          <option v-for="action in group" :key="action.action" :value="action.action">
            {{ action.name }}
          </option>
        </optgroup>
      </select>
    </div>
    <div>
      --------------------------
    </div>
    <div class="request-section">
      Uid:
      <input v-model="uid" placeholder="Enter UID"/>
      Data:
      <textarea v-model="data" placeholder="Enter Data (JSON format)"></textarea>
      <button @click="sendMessage">Send</button>
    </div>
    <div class="response-section">
      <h3>Responses:</h3>
      <div v-for="(response, index) in responses" :key="index" class="response-item">
        <pre>{{ response }}</pre>
        <button @click="deleteResponse(index)">Delete</button>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('App mounted');
    this.wsUrl = localStorage.getItem('wsUrl');
    if (this.wsUrl) {
      this.connectWebSocket();
    }
  },
  data() {
    return {
      wsUrl: '',
      token: '',
      uid: '',
      selectedAction: '',
      data: '',
      websocket: null,
      isConnected: false,
      responses: [],
      // actions: [{'name': '发送登录短信验证码', 'action': 'login.send_mp_code', 'tag': 'login'}, {'name': '手机登录', 'action': 'login.login_by_mp', 'tag': 'login'}, {'name': '获取用户信息', 'action': 'user.get_user_info', 'tag': 'user'}, {'name': '获取任务列表', 'action': 'task.get_tasks', 'tag': 'task'}, {'name': '获取任务脑力训练列表', 'action': 'task.get_brain_trainings', 'tag': 'task'}, {'name': '开始任务', 'action': 'task.start_task', 'tag': 'task'}, {'name': '完成任务游戏(串烧)     :param data:     :type kwargs: dict', 'action': 'task.complete_brain_training', 'tag': 'task'}, {'name': '聊天', 'action': 'chat.chat', 'tag': 'chat'}, {'name': '获取问候语(开场白)，每次选择用户进入聊天时调用', 'action': 'chat.get_greeting', 'tag': 'chat'}, {'name': 'ping', 'action': 'ping', 'tag': ''}],
      actions: [{
        'name': '发送登录短信验证码',
        'action': 'login.send_mp_code',
        'tag': 'login'
      }, {'name': '通过token登录', 'action': 'login.login_by_token', 'tag': 'login'}, {
        'name': '手机登录',
        'action': 'login.login_by_mp',
        'tag': 'login'
      }, {'name': '设置邀请码', 'action': 'user.set_invite_code', 'tag': 'user'}, {
        'name': '获取用户信息',
        'action': 'user.get_user_info',
        'tag': 'user'
      }, {'name': '更新用户信息', 'action': 'user.update_user_info', 'tag': 'user'}, {
        'name': '获取任务列表',
        'action': 'task.get_tasks',
        'tag': 'task'
      }, {
        'name': '获取任务脑力训练列表',
        'action': 'task.get_brain_trainings',
        'tag': 'task'
      }, {
        'name': '获取任务脑力训练列表',
        'action': 'task.get_grouped_brain_trainings',
        'tag': 'task'
      }, {'name': '开始任务', 'action': 'task.start_task', 'tag': 'task'}, {
        'name': '完成任务游戏(串烧)',
        'action': 'task.complete_brain_training',
        'tag': 'task'
      }, {'name': 'stop', 'action': 'chat.stop', 'tag': 'chat'}, {
        'name': '聊天',
        'action': 'chat.chat',
        'tag': 'chat'
      }, {
        'name': '获取问候语(开场白)，每次选择用户进入聊天时调用',
        'action': 'chat.get_greeting',
        'tag': 'chat'
      }, {'name': '结束游戏', 'action': 'game.get_games', 'tag': 'game'}, {
        'name': '结束游戏',
        'action': 'game.end_session',
        'tag': 'game'
      }, {'name': '开始游戏', 'action': 'game.start_session', 'tag': 'game'}, {
        'name': '匹配一次',
        'action': 'game.match_item',
        'tag': 'game'
      }, {'name': '过关', 'action': 'game.pass_level', 'tag': 'game'}, {
        'name': 'check_notification',
        'action': 'notification.check',
        'tag': 'notification'
      }, {
        'name': '获取未读通知',
        'action': 'notification.get_notifications',
        'tag': 'notification'
      }, {'name': '标记通知为已读', 'action': 'notification.read', 'tag': 'notification'}, {
        'name': 'ping',
        'action': 'ping',
        'tag': ''
      }]

    };
  },
  computed: {
    groupedActions() {
      return this.actions.reduce((groups, action) => {
        const tag = action.tag || 'General';
        if (!groups[tag]) {
          groups[tag] = [];
        }
        groups[tag].push(action);
        // console.log("groups", groups)
        return groups;
      }, {});
    },
  },
  methods: {
    connectWebSocket() {
      if (this.websocket) {
        this.websocket.close();
      }
      this.websocket = new WebSocket(this.wsUrl);
      this.websocket.onopen = () => {
        localStorage.setItem('wsUrl', this.wsUrl);

        this.isConnected = true;
        console.log('WebSocket connected');
      };
      this.websocket.onmessage = (event) => {
        console.log('Received message:', event.data);
        const message = JSON.parse(event.data);
        if (message.uid === this.uid && message.action === this.selectedAction) {
          this.responses.push(JSON.stringify(message, null, 2));
        }
      };
      this.websocket.onclose = () => {
        this.isConnected = false;
        console.log('WebSocket disconnected');
      };
      this.websocket.onerror = (error) => {
        alert("连接失败！")
        console.error('WebSocket error:', error);
      };
    },
    sendMessage() {
      if (this.isConnected && this.websocket) {
        let body = null;
        try {
          body = JSON.parse(this.data)
        } catch (e) {
          alert("data数据格式错误！")
          return
        }
        const request = {
          token: this.token,
          uid: this.uid,
          action: this.selectedAction,
          data: body,
        };
        console.log('Sending request:', request);
        this.websocket.send(JSON.stringify(request));

      } else {
        alert('WebSocket is not connected');
      }
    },
    deleteResponse(index) {
      this.responses.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.request-section {
  margin-bottom: 20px;
}

textarea {
  width: 100%;
  height: 100px;
  margin-top: 10px;
}

.response-section {
  margin-top: 20px;
}

.response-item {
  background: #f4f4f4;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}
</style>
